module.exports = __webpack_public_path__ + "media/welcome.3e82e4a1.mp3";